import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'

export const Container = styled.div`
  width: 100%;
`

export const List = styled.ul`
  margin: 0;
  gap: 16px;
  padding: 0;
  height: auto;
  min-height: 0;
  display: flex;
  list-style: none;
  margin-bottom: 16px;
  flex-direction: column;
`

export const ErrorMessage = styled.div`
  color: ${colors.feedback.errorDark};
  font-size: 12px;
  margin: 8px 0;
`

export const InfoMessage = styled.div`
  display: flex;
  align-items: center;
  margin: 8px 0;
  ${typography.down1.regularSans};
  color: ${colors.feedback.infoDark};
  svg {
    font-size: 18px;
    margin-left: 10px;
    color: ${colors.feedback.infoDark};
  }
`
